import { Particle } from "../particle";
import { colorConstant, hold, lerp, linearMotion, randomAngle, randomBetween } from "../interpolation";

export class AirBlastBurstParticle extends Particle {
	constructor(originX: number, originY: number) {
		const angle = randomAngle();
		const speed = randomBetween(2.0, 5.0);
		const vx = Math.cos(angle) * speed;
		const vy = Math.sin(angle) * speed;

		const r = randomBetween(220, 255);
		const g = randomBetween(230, 255);
		const b = randomBetween(240, 255);

		super(originX, originY, {
			ttl: randomBetween(250, 450),
			size: lerp(0.4, 0.15),
			opacity: hold(0.8, 0.6, lerp(0.8, 0.0)),
			color: colorConstant(r, g, b),
			rotation: lerp(0, randomBetween(-2, 2)),
			position: linearMotion(vx, vy),
		});
	}
}
